import React, { Component } from 'react';
import { Select, Option } from 'informed';

import states from '../../util/us-states-list';

export class StateSelect extends Component {
  render() {
    const { name, title, width } = this.props;

    return (
      <li className={`search-form__item ${width}`}>
        <label className="search-form__label" htmlFor={name}>
          {title}
        </label>
        <Select className="search-form__select" field={name} id={name}>
          <Option value="" disabled hidden />
          {Object.entries(states).map((state, i) => (
            <Option value={state[0]} key={i}>
              {state[1]}
            </Option>
          ))}
        </Select>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/StateSelect.js